import { Flex, Button, useStyles } from '@archipro-design/aria';
import { Filter } from '@archipro-design/icons';

import { applyCount } from '@modules/search/components/filter-drawer/FilterDrawer';

import FilterBarFilters from '@modules/search/components/search-filter-section/FilterBarFilters';

import * as S from './CategoryFilterSection.style';

import SearchSort from '@modules/search/components/search-filter-section/SearchSort';
import { useSearchSortOptions } from '~/modules/search/hook/use-search-sort-options';

import type { CategoryFilterSectionProps } from './CategoryFilterSection';

export const CategoryFilterSection = ({
    initialStates,
    category,
    toggleFilterDrawer,
    filterDrawerOpen,
    componentBefore,
    searchFilters,
}: CategoryFilterSectionProps) => {
    const { css } = useStyles();

    const { appliedFilters, filterBarFilters, updateFilter } = searchFilters;

    const optionResult = useSearchSortOptions({ category });

    return (
        <div className={css(S.FilterSectionWrapper)}>
            <Flex space="between" vAlign="center">
                {componentBefore}
                <Flex column gap="space-24">
                    <Flex
                        vAlign="center"
                        gap="space-48"
                        hAlign="end"
                        className={css(S.FilterActionContainer)}
                    >
                        {filterBarFilters && filterBarFilters.length > 0 && (
                            <FilterBarFilters
                                filters={filterBarFilters}
                                updateFilter={updateFilter}
                            />
                        )}
                        {initialStates && (
                            <Button
                                transparent
                                size={18}
                                variables={{ buttonPadding: 0, iconPadding: 8 }}
                                iconBefore={<Filter />}
                                onClick={toggleFilterDrawer}
                                styles={{
                                    fontWeight: 500,
                                }}
                            >
                                {applyCount(
                                    `${
                                        filterDrawerOpen ? 'Hide' : 'Show'
                                    } Filters`,
                                    appliedFilters?.length ?? 0
                                )}
                            </Button>
                        )}

                        {optionResult.items.length > 0 && (
                            <SearchSort optionResult={optionResult} />
                        )}
                    </Flex>
                </Flex>
            </Flex>
        </div>
    );
};
